import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import { Mixpanel } from '../../redux/Mixpanel';
import {
    OtherRecurringBills,
    handleChangeBillsAmount,
    handleChangeBillsOptions,
    getBillsItems,
    getBillsOptions,
    getBillsName,
    handleAddItem,
    handleDeleteItem,
    isValidBillsItems
} from '../../components/OtherRecurringBills';

import {
    Container,
    Button,
    Row,
    Col,
    Form,
    FormFeedback,
    FormGroup,
    Input,
    Label,
    UncontrolledTooltip,
    InputGroup
} from 'reactstrap';
import CustomInput from '../../components/CustomInput';
import { colorTheme, OCCUPANT_TYPE, UNIFORM_RESOURCE_LOCATORS } from '../../utils/constants';
import CustomLabel from '../../components/CustomLabel';
import ShowMoreButton from './ShowMoreButton';
import { createPenaltyDays } from '../../utils';
import { Typeahead } from 'react-bootstrap-typeahead';

import {
    check_empty_field,
    check_if_number,
    check_mpesa_shortcodes_length,
    check_percentage,
    check_penalty_day_of_month,
    clear_error_from_field
} from './validationChecks';

import {
    addProperty,
    updateProperty,
    deleteProperty,
    showLoading,
    showFeatureComingSoon,
    fetchCurrency,
    fetchOptions,
    fetchPropertiesUnitsTenants
} from '../../redux/actions';


import { PAYBILL, TILL_NUMBER } from '../../utils/constants';
import { IonButton, IonIcon, IonRadio, IonRadioGroup } from '@ionic/react';
import { arrowForwardOutline, informationCircle, trashOutline } from 'ionicons/icons';
// setDefaultLocale('en');


const mapStateToProps = state => {
    return {
        properties: state.properties,
        currency: state.currency,
        options: state.options,
        units: state.units
    };
}

const mapDispatchToProps = {
    addProperty,
    updateProperty,
    deleteProperty,
    showLoading,
    showFeatureComingSoon,
    fetchCurrency,
    fetchOptions,
    fetchPropertiesUnitsTenants
};


class PropertyForm extends React.Component{
    constructor(props) {
        super(props);

        this.unitFormButtonRef = React.createRef();
        let property = {
            propertyId: "",
            propertyName: "",
            numUnits: "",
            city: "",
            address: "",
            waterRate: 0,
            electricityRate: 0,
            mpesaShortcode: "",
            mpesaShortcodeTypes: [PAYBILL, TILL_NUMBER],
            mpesaShortcodeType: PAYBILL, // or TILL_NUMBER or paybill
            tillNumber: "",
            penaltyType: "",
            fixedPenaltyAmount: 0,
            percentagePenaltyAmount: 0,
            managementFeeType: "",
            managementFeeFixedAmount: 0,
            managementFeePercentage: 0,
            taxRate: 7.5,
            otherRecurringBillsItems:[{ bill: [], amount: ""}],
            otherRecurringBillsItemOptions: [],
            automaticallyPenalize: false,
            penaltyDayOfMonth: "",
            showOptionalFields: false,
            showUploadSpreadSheet: props.showUploadSpreadSheet == false? false: true,
            notes:"",
            companyName: "",
            paymentInstructions: "",
            showAlert: false,
            invoiceItems: [],
            invoiceItemOptions: [],
        };

        this.state = {
            ...property,
            property,
            penaltyDays: [],
            errors: {
                propertyName: "",
                numUnits: "",
                city: "",
                address: "",
                waterRate: "",
                electricityRate: "",
                mpesaShortcode: "",
                tillNumber: "",
                fixedPenaltyAmount: "",
                percentagePenaltyAmount: "",
                penaltyDayOfMonth: "",
                managementFeeType: "",
                managementFeeFixedAmount: "",
                managementFeePercentage: "",
                taxRate: "",
                otherRecurringBillsItems: property.otherRecurringBillsItems.map( () => ({bill: [], amount: ""})),
                notes: "",
                companyName: "",
                paymentInstructions: "",
                invoiceItems: "",
            },
            numErrors: 0
        }
        this.penaltyDays = [];
        this.propertyNameInput = React.createRef();
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.setPropertyValues = this.setPropertyValues.bind(this);
        this.handleChangeBillsAmount = handleChangeBillsAmount.bind(this);
        this.handleChangeBillsOptions = handleChangeBillsOptions.bind(this);
        this.getBillsItems = getBillsItems.bind(this);
        this.getBillsName = getBillsName.bind(this);
        this.getBillsOptions = getBillsOptions.bind(this);
        this.handleAddItem = handleAddItem.bind(this);
        this.handleDeleteItem = handleDeleteItem.bind(this);
        this.isValidBillsItems= isValidBillsItems.bind(this);

    }

    async fetchInitialData() {
        await Promise.all([
          (async () => {
            if (_.isEmpty(this.props.options)) {
              this.props.showLoading(true);
              await this.props.fetchOptions();
            }
          })(),
          (async () => {
            if (_.isEmpty(this.props.properties)) {
              this.props.showLoading(true);
              await this.props.fetchPropertiesUnitsTenants();
            }
          })(),
          (async () => {
            if (_.isEmpty(this.props.currency)) {
              this.props.showLoading(true);
              await this.props.fetchCurrency();
            }
          })(),
        ]);
      }

      async componentDidMount() {
        await this.fetchInitialData();
        this.handleTutorialAlert();
        this.handlePropertyDetails();
        this.handleOptionsDetails();
      }

      handleTutorialAlert() {
        const searchParams = new URLSearchParams(this.props.location.search);

        if (searchParams.has('tutorial')) {
          this.setState({ showAlert: true });
        } else {
          this.setState({ showAlert: false });
        }
      }

      handleOptionsDetails() {
        if (this.props.options) {
            const invoiceItems = this.props.options.invoiceItems.map((item) => ({ label: item }));

            const searchParams = new URLSearchParams(this.props.location.search);
            const propertyId = searchParams.get('propertyId');

            const invoiceItemsRedux = this.props.properties[propertyId]
            ? this.props.properties[propertyId].managementInvoices.map(item => ({ id: item, label: item }))
            : [];

            let invoiceItemOptions = invoiceItems.filter(
                (item) => !invoiceItemsRedux.some((i) => i.label === item.label)
            );

            this.setState({
                invoiceItemOptions
            });
        }
    }

      handlePropertyDetails() {
        const searchParams = new URLSearchParams(this.props.location.search);
        let propertyProps = this.props.property || null;

        if (searchParams.has('propertyId')) {
          const propertyId = searchParams.get('propertyId');
          const property = this.props.properties[propertyId];

          if (property) {
            propertyProps = property;
          }
        }

        this.setState((prevState) => ({
          ...this.getPropertyStateFromProps(propertyProps),
          showUploadSpreadSheet: this.props.showUploadSpreadSheet === false ? false : true,
          otherRecurringBillsItems: this.getOtherRecurringBillsItems(propertyProps),
          otherRecurringBillsItemOptions: this.getOtherRecurringBillsItemOptions(propertyProps)
        }));
      }

      getPropertyStateFromProps(propertyProps) {
        return {
            propertyId: propertyProps ? propertyProps.propertyId : "",
            propertyName: propertyProps ? propertyProps.propertyName : "",
            numUnits: propertyProps ? propertyProps.numUnits : "",
            city: propertyProps ? propertyProps.city : "",
            address: propertyProps ? propertyProps.address : "",
            waterRate: propertyProps ? propertyProps.waterRate : 0,
            electricityRate: propertyProps ? propertyProps.electricityRate : 0,
            mpesaShortcode: propertyProps ? propertyProps.mpesaShortcode : "",
            mpesaShortcodeType: propertyProps ? (propertyProps.mpesaShortcodeType? propertyProps.mpesaShortcodeType : PAYBILL) : PAYBILL,
            tillNumber: propertyProps ? propertyProps.tillNumber : "",
            penaltyType: propertyProps ? propertyProps.penaltyType : "",
            fixedPenaltyAmount: propertyProps ? propertyProps.fixedPenaltyAmount : 0,
            percentagePenaltyAmount: propertyProps ? propertyProps.percentagePenaltyAmount : 0,
            managementFeeType: propertyProps ? propertyProps.managementFeeType : "",
            managementFeeFixedAmount: propertyProps ? propertyProps.managementFeeFixedAmount : 0,
            managementFeePercentage: propertyProps ? propertyProps.managementFeePercentage : 0,
            taxRate: propertyProps ? propertyProps.taxRate : 7.5,
            automaticallyPenalize: propertyProps ? propertyProps.automaticallyPenalize : false,
            penaltyDayOfMonth: propertyProps ? propertyProps.penaltyDayOfMonth : "",
            showOptionalFields: false,
            showUploadSpreadSheet: this.props.showUploadSpreadSheet === false ? false : true,
            notes: propertyProps ? propertyProps.notes : "",
            companyName: propertyProps ? propertyProps.companyName : "",
            paymentInstructions: propertyProps ? propertyProps.paymentInstructions : "",
            invoiceItems: propertyProps ? propertyProps.managementInvoices.map(item => ({ id: item, label: item })) : [],
            penaltyDays: createPenaltyDays(),

        };
      }

      handleChangedInvoiceItemOptions(selected = []) {
        if (!Array.isArray(selected)) {
            console.warn("Invalid selection.");
            return;
        }

        let invoiceItems = [...selected];

        let removedItems = this.state.invoiceItems.filter(
            (item) => !selected.some((s) => s.label === item.label)
        );

        let invoiceItemOptions = [...this.state.invoiceItemOptions, ...removedItems];

        invoiceItemOptions = invoiceItemOptions.filter(
            (item, index, self) => index === self.findIndex((t) => t.label === item.label)
        );

        this.setState({ invoiceItems, invoiceItemOptions });
    }

      getOtherRecurringBillsItems(propertyProps) {
        return propertyProps && propertyProps.otherRecurringBillsItems && propertyProps.otherRecurringBillsItems.length > 0 ?
          propertyProps.otherRecurringBillsItems.map(this.getBillsItems.bind(this)) :
          this.state.otherRecurringBillsItems;
      }

      getOtherRecurringBillsItemOptions(propertyProps) {
        return propertyProps ?
          this.getBillsOptions((propertyProps.otherRecurringBillsItems).map(this.getBillsItems.bind(this)), propertyProps.otherRecurringBillsItems, this.props.options) :
          this.props.options.otherRecurringBillItems.map(this.getBillsName.bind(this));
      }

      componentDidUpdate(prevProps, prevState) {
        if (!prevProps.propertyId && this.props.propertyId) {
            //added this so the users are shown the add unit button via scrolling to it which they would have otehrwise missed
          this.scrollToUnitFormButton();
        }
      }

      scrollToUnitFormButton() {
        if (this.unitFormButtonRef.current) {
          this.unitFormButtonRef.current.scrollIntoView({ behavior: 'auto' });
        }
      }

    validateInput(name, value){
        let val = String(value);
        let autoPenalizeChecked = value;
        let isValid = true;
        let errors = this.state.errors;
        let checks = [];
        switch(name){
            case "propertyName":
                checks = [check_empty_field]
                break;
            case "numUnits":
                checks = [check_empty_field, check_if_number];
                break;
            case "city":
                checks = [check_empty_field];
                break;
            case "waterRate":
                checks = [check_if_number];
                break;
            case "electricityRate":
                checks = [check_if_number];
                break;
            case "mpesaShortcode":
                checks = [check_if_number, check_mpesa_shortcodes_length];
                break;
            case "tillNumber":
                checks = [check_if_number, check_mpesa_shortcodes_length];
                break;
            case "fixedPenaltyAmount":
                checks = [check_if_number];
                break;
            case "percentagePenaltyAmount" :
                checks = [check_if_number, check_percentage];
                break;
            case "managementFeePercentage" :
                checks = [check_if_number, check_percentage];
                break;
            case "managementFeeFixedAmount" :
                checks = [check_if_number];
                break;
            case "taxRate" :
                checks = [check_if_number, check_percentage];
                break;
            case "automaticallyPenalize":
                val = this.state.penaltyDayOfMonth;
                name = "penaltyDayOfMonth"
                if(autoPenalizeChecked){
                    checks = [check_penalty_day_of_month]
                }else{
                    checks = [clear_error_from_field]
                }
                break
            case "penaltyDayOfMonth":
                if(this.state.automaticallyPenalize){
                    checks = [check_penalty_day_of_month]
                }else{
                    checks = [clear_error_from_field]
                }
                break
            default:
                break;
        }
        for (let index in checks){
            let previousError = errors[name];
            errors[name] = checks[index](val);
            if (errors[name].length > 0){
                if (previousError.length == 0){
                    this.setState((prevState)=>({numErrors: prevState.numErrors + 1}));
                }
                isValid = false;
                break;
            }else if(previousError.length > 0){
                this.setState((prevState)=>({numErrors: prevState.numErrors - 1}));
            }
        }
        return isValid;
    }

    handleChange(event) {
        const target = event.target;
        let name = target.name;
        let val = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({[name]: val});
        this.validateInput(name, val);
    }

    getShortcodeType(){
        // only sends shortcode types(paybill or till number) to the backend if the fields are number fields are not empty.
        let shortcodeType = "";
        if (this.state.mpesaShortcodeType===PAYBILL && this.state.mpesaShortcode){
            shortcodeType = PAYBILL;
        } else if(this.state.mpesaShortcodeType===TILL_NUMBER && (this.state.mpesaShortcode || this.state.tillNumber)){
            shortcodeType = TILL_NUMBER;
        }
        return shortcodeType
    }


    async handleSubmit(event) {
        event.preventDefault();
        let fields = ["propertyName", "numUnits", "city", "address", "waterRate",
            "electricityRate", "mpesaShortcode", "tillNumber", "penaltyDayOfMonth",
            "managementFeePercentage", "managementFeeFixedAmount", "taxRate"];
        let invalid_fields = fields.filter((field)=> !(this.validateInput(field, this.state[field])));
        const isValidBillItems= await isValidBillsItems(this.state.otherRecurringBillsItems, this.setState.bind(this));
        if (invalid_fields.length == 0 && isValidBillItems) {
            const otherRecurringBillsItems = this.state.otherRecurringBillsItems.filter(
                otherRecurringBillsItems => otherRecurringBillsItems.bill.length > 0 && otherRecurringBillsItems.amount.length > 0
            ).map(otherRecurringBillsItems => ({
                bill: otherRecurringBillsItems.bill[0].id || otherRecurringBillsItems.bill[0],
                amount: otherRecurringBillsItems.amount
            }));
            this.props.showLoading(true);
            let payload = {
                propertyName: this.state.propertyName,
                numUnits: this.state.numUnits,
                city: this.state.city,
                address: this.state.address,
                waterRate: this.state.waterRate? parseFloat(this.state.waterRate): 0,
                electricityRate: this.state.electricityRate? parseFloat(this.state.electricityRate) : 0,
                mpesaShortcode: this.state.mpesaShortcode,
                mpesaShortcodeType: this.getShortcodeType(),
                tillNumber: this.state.tillNumber,
                penaltyType: this.state.penaltyType ? this.state.penaltyType.toUpperCase() : "",
                fixedPenaltyAmount: this.state.fixedPenaltyAmount,
                percentagePenaltyAmount: this.state.percentagePenaltyAmount,
                automaticallyPenalize: this.state.automaticallyPenalize,
                penaltyDayOfMonth: this.state.penaltyDayOfMonth? this.state.penaltyDayOfMonth : "0",
                managementFeeType: this.state.managementFeeType ? this.state.managementFeeType : "",
                managementFeeFixedAmount: this.state.managementFeeFixedAmount,
                managementFeePercentage: this.state.managementFeePercentage,
                taxRate: this.state.taxRate || 0,
                otherRecurringBillsItems,
                notes: this.state.notes,
                companyName: this.state.companyName,
                paymentInstructions: this.state.paymentInstructions,
                managementInvoices: this.state.invoiceItems.map((item) => item.label),
            };
            let result;
            if (this.state.propertyId){
                payload["propertyId"] = this.state.propertyId;
                result = await this.props.updateProperty(payload);
            }else{
                result = await this.props.addProperty(payload);
            }
            if(result && result.payload){
                this.setState({
                    ...result.payload,
                    otherRecurringBillsItems: result.payload.otherRecurringBillsItems.map(this.getBillsItems.bind(this)),
                    errors: {
                        ...this.state.errors,
                        otherRecurringBillsItems: result.payload.otherRecurringBillsItems.map((item) => ({bill: "", amount: ""}))
                    }
                });
            }
        }
        Mixpanel.track("Property form: submit btn");
    }

    setPropertyValues({propertyId="", propertyName="", numUnits="", city="", address="",
        waterRate=0, electricityRate=0, mpesaShortcode="", tillNumber="", mpesaShortcodeType=PAYBILL,
        penaltyType="", fixedPenaltyAmount=0, percentagePenaltyAmount=0, automaticallyPenalize=false,
        penaltyDayOfMonth="", managementFeeType="", managementFeeFixedAmount=0, managementFeePercentage=0,
        taxRate=7.5, notes="", paymentInstructions="", companyName="", otherRecurringBillsItems = [{bill: [], amount: ""}]} = {}){
        const otherRecurringBillsItemOptions = this.getBillsOptions([], [], this.props.options)
        this.setState({
        propertyId, propertyName, numUnits, city, address, waterRate, electricityRate, mpesaShortcode, tillNumber, mpesaShortcodeType,
        penaltyType, fixedPenaltyAmount, percentagePenaltyAmount, automaticallyPenalize, penaltyDayOfMonth,
        managementFeeType, managementFeeFixedAmount, managementFeePercentage, taxRate, notes, paymentInstructions, companyName, otherRecurringBillsItems, otherRecurringBillsItemOptions
        });
    }

    handleDelete(propertyId, event) {
        event.preventDefault();
        const confirmDelete = window.confirm(`Are you sure you want to delete this property?`);

        if (confirmDelete) {
            this.props.showLoading(true);
            this.setPropertyValues();
            this.props.deleteProperty(propertyId);
            Mixpanel.track("Property form: delete btn");
        }
    }

    handleAlertClose = () => {
        this.setState({ showAlert: false });
    }

    handleCancelUpdate(event){
        event.preventDefault();
        this.setPropertyValues();
        Mixpanel.track("Property form: cancel update btn");
    }

    handleClear(event){
        event.preventDefault();
        this.setPropertyValues();
        Mixpanel.track("Property form: clear btn");
    }

    async handleUnitsFormButton(event) {
        event.preventDefault();
        if (this.state.propertyId) {
            const searchParams = new URLSearchParams(this.props.location.search);
            const url = searchParams.has('tutorial') ?
                `${UNIFORM_RESOURCE_LOCATORS.unitForm}?tutorial&propertyId=${this.state.propertyId}` :
                `${UNIFORM_RESOURCE_LOCATORS.unitForm}?propertyId=${this.state.propertyId}`;
            await this.props.history.push(url);
        }
      }

    onClickUploadSpreadSheet(event){
        event.preventDefault();
        this.props.showFeatureComingSoon();
        Mixpanel.track("Property form: upload spreadsheet btn");
    }

    handleRadioButtons(event){
        const selectedValue = event.detail.value;
        this.setState({
            mpesaShortcodeType: selectedValue
        })

    }

    renderRequiredFields(){
        return (
            <React.Fragment>

                {/* Property Name */}
                <FormGroup row>
                    <CustomLabel
                        sm={12} md={4}
                        for={"propertyName"}
                    >
                        Property Name
                    </CustomLabel>

                    <Col style={{maxWidth: '450px'}} sm={12} md={7}>
                        <InputGroup>
                            <Input
                                id="propertyName"
                                name="propertyName"
                                placeholder='Property Name ...'
                                value={this.state.propertyName}
                                onChange={this.handleChange}
                                invalid={this.state.errors.propertyName.length > 0}
                                ref={this.propertyNameInput}
                            />
                            <FormFeedback>{this.state.errors.propertyName}</FormFeedback>
                        </InputGroup>
                    </Col>
                </FormGroup>

                {/* Number of Units */}
                <FormGroup row>
                    <CustomLabel
                        sm={12} md={4}
                        for={"numUnits"}
                    >
                        Number of units
                    </CustomLabel>

                    <Col style={{maxWidth: '450px'}} sm={12} md={7}>
                        <InputGroup>
                            <Input
                                id="numUnits"
                                name="numUnits"
                                placeholder='0'
                                value={this.state.numUnits}
                                onChange={this.handleChange}
                                invalid={this.state.errors.numUnits.length > 0}
                            />
                            <FormFeedback>{this.state.errors.numUnits}</FormFeedback>
                        </InputGroup>
                    </Col>
                </FormGroup>

                {/* City */}
                <FormGroup row>
                    <CustomLabel
                        sm={12} md={4}
                        for={"city"}
                    >
                        City
                    </CustomLabel>

                    <Col style={{maxWidth: '450px'}} sm={12} md={7}>
                        <InputGroup>
                            <Input
                                id="city"
                                name="city"
                                placeholder='City or nearest town ...'
                                value={this.state.city}
                                onChange={this.handleChange}
                                invalid={this.state.errors.city.length > 0}
                            />
                            <FormFeedback>{this.state.errors.city}</FormFeedback>
                        </InputGroup>
                    </Col>
                </FormGroup>

            </React.Fragment>
        );
    }

    handleDeletePenalty = () => {
        this.setState({
          penaltyType: '',
          fixedPenaltyAmount: 0,
          percentagePenaltyAmount: 0,
          automaticallyPenalize: false,
          penaltyDayOfMonth: ''
        });
      };

    renderPenaltyField(){
        const FIXED_PENALTY = 'FIXED';
        const PERCENTAGE_RENT_PENALTY = 'PERCENTAGE_RENT';
        const PERCENTAGE_BALANCE_PENALTY = 'PERCENTAGE_BALANCE';
        let toolTipText={
            'PERCENTAGE_RENT': `A penalty of the entered percentage of the rent amount will be charged on every ${this.props.options.userAccountType === OCCUPANT_TYPE ? "tenant" : "member"} who pays their rent late`,
            'PERCENTAGE_BALANCE': `A penalty of the entered percentage of the account balance amount will be charged on every ${this.props.options.userAccountType === OCCUPANT_TYPE ? "tenant" : "member"} who pays their rent late`
        }
        return (
            <FormGroup row>
                <CustomLabel sm={12} md={4} for="penalty">
                    Rent Payment Penalty (optional)
                </CustomLabel>

                <Col style={{maxWidth: '450px'}} sm={12} md={7}>
                    <CustomInput
                        type="select"
                        id="penaltyType"
                        className="mr-2"
                        name="penaltyType"
                        value={this.state.penaltyType}
                        onChange={this.handleChange}
                    >
                        <option key={""} value={""}>Select Penalty Type</option>
                        <option key={FIXED_PENALTY} value={FIXED_PENALTY}>Fixed Amount</option>
                        <option key={PERCENTAGE_RENT_PENALTY} value={PERCENTAGE_RENT_PENALTY}>Percentage of Rent</option>
                        <option key={PERCENTAGE_BALANCE_PENALTY} value={PERCENTAGE_BALANCE_PENALTY}>Percentage of Balance</option>
                    </CustomInput>

                    {
                        (this.state.penaltyType != "") && (
                            <Row className="pb-3 mt-3">
                                <Row>
                                    <Col>
                                        {(this.state.penaltyType === FIXED_PENALTY) && (
                                            <FormGroup className="ml-3">
                                                <Label for="fixedPenaltyAmount">
                                                    Fixed Penalty Amount
                                                </Label>
                                                <IonIcon id="fixedPenaltyAmount" icon={informationCircle}></IonIcon>
                                                <Input
                                                    id="fixedPenaltyAmountInput"
                                                    name="fixedPenaltyAmount"
                                                    placeholder='0'
                                                    value={this.state.fixedPenaltyAmount}
                                                    onChange={this.handleChange}
                                                    invalid={this.state.errors.fixedPenaltyAmount.length > 0}
                                                />
                                                <UncontrolledTooltip placement="top" target="fixedPenaltyAmount">
                                                    A penalty of the entered amount will be charged on every {this.props.options.userAccountType === OCCUPANT_TYPE ? "tenant" : "member"} who pays their rent late
                                                </UncontrolledTooltip>
                                                <FormFeedback>{this.state.errors.fixedPenaltyAmount}</FormFeedback>
                                            </FormGroup>
                                        )}
                                        {(this.state.penaltyType === PERCENTAGE_RENT_PENALTY || this.state.penaltyType === PERCENTAGE_BALANCE_PENALTY) && (
                                            <FormGroup className="ml-3">
                                                <Label for="percentagePenaltyAmount">
                                                    Percentage Penalty
                                                </Label>
                                                <IonIcon id="percentagePenaltyAmount" icon={informationCircle}></IonIcon>
                                                <Input
                                                    id="percentagePenaltyAmount"
                                                    name="percentagePenaltyAmount"
                                                    placeholder='0'
                                                    value={this.state.percentagePenaltyAmount}
                                                    onChange={this.handleChange}
                                                    invalid={this.state.errors.percentagePenaltyAmount.length > 0}
                                                />
                                                <UncontrolledTooltip placement="top" target="percentagePenaltyAmount">
                                                    {toolTipText[this.state.penaltyType]}
                                                </UncontrolledTooltip>
                                                <FormFeedback>{this.state.errors.percentagePenaltyAmount}</FormFeedback>
                                            </FormGroup>
                                        )}
                                    </Col>
                                    {this.state.penaltyType !== '' && (
                                        <Col className="d-flex align-items-end mb-3 ml-3" style={{ maxWidth: '50px' }}>
                                          <Button outline color="secondary" onClick={() => this.handleDeletePenalty()}>
                                                <IonIcon icon={trashOutline} />
                                          </Button>
                                        </Col>
                                    )}
                                </Row>

                                {/* Automatically penalize */}
                                <Row>
                                    <Col className="ml-3" lg={12}>
                                        {
                                            <FormGroup>
                                                <Label check className="ml-3">
                                                    <Input
                                                        type="checkbox"
                                                        id="automaticallyPenalize"
                                                        name="automaticallyPenalize"
                                                        onChange={this.handleChange}
                                                        checked={this.state.automaticallyPenalize}
                                                    />{' '}
                                                    Automatically penalize {this.props.options.userAccountType === OCCUPANT_TYPE ? "tenants" : "members"} upon late payment <IonIcon id="automaticallyPenalize" icon={informationCircle}></IonIcon>
                                                </Label>
                                                <UncontrolledTooltip placement="top" target="automaticallyPenalize">
                                                    Automatically create late rent payment penalty invoices(bills) for each {this.props.options.userAccountType === OCCUPANT_TYPE ? "tenant" : "member"} on a certain date.
                                                </UncontrolledTooltip>
                                            </FormGroup>

                                        }

                                        {/* Penalty day of month */}
                                        {
                                            (this.state.automaticallyPenalize) && (
                                                <FormGroup row>
                                                    <Label for="penaltyDayOfMonth">
                                                        Penalty day of month
                                                        <IonIcon id="penaltyDayOfMonth" icon={informationCircle}></IonIcon>
                                                        <br/>
                                                        (When to apply the penalty)
                                                    </Label>

                                                    <CustomInput
                                                        type="select"
                                                        id="penaltyDayOfMonthInput"
                                                        name="penaltyDayOfMonth"
                                                        autoComplete="off"
                                                        placeholder=' penalty date ...'
                                                        value={this.state.penaltyDayOfMonth}
                                                        onChange={this.handleChange}
                                                        invalid={this.state.errors.penaltyDayOfMonth.length > 0}
                                                    >
                                                        <option key="empty" value={0}>{""}</option>
                                                        {this.state.penaltyDays.map((item, index) => (
                                                            <option key={item["value"]} value={item["value"]}>{item["day"]}</option>
                                                        ))}
                                                    </CustomInput>

                                                    <FormFeedback>{this.state.errors.penaltyDayOfMonth}</FormFeedback>
                                                </FormGroup>
                                            )
                                        }

                                    </Col>
                                </Row>
                            </Row>
                        )
                    }

                </Col>
            </FormGroup>
        );
    }

    renderManagementFeeField(){
        const FIXED_MANAGEMENT_FEE = 'fixed';
        const PERCENTAGE_MANAGEMENT_FEE = 'percentage';
        const PERCENTAGE_INVOICES = 'percentage_invoice';
        return (
            <FormGroup row>
                <CustomLabel sm={12} md={4} for="management">
                    Management Fee (optional)
                </CustomLabel>

                <Col style={{maxWidth: '450px'}} sm={12} md={7}>
                    <CustomInput
                        type="select"
                        id="managementFeeType"
                        className="mr-2"
                        name="managementFeeType"
                        value={this.state.managementFeeType}
                        onChange={this.handleChange}
                    >
                        <option key={""} value={""}>Select Management Fee Type</option>
                        <option key={FIXED_MANAGEMENT_FEE} value={FIXED_MANAGEMENT_FEE}>Fixed Amount</option>
                        <option key={PERCENTAGE_MANAGEMENT_FEE} value={PERCENTAGE_MANAGEMENT_FEE}>Percentage of Total Rent Collected</option>
                        <option key ={PERCENTAGE_INVOICES} value={PERCENTAGE_INVOICES}>Percentage of Total Invoices</option>
                    </CustomInput>

                    {
                        (this.state.managementFeeType != "") && (
                            <Row className="pb-3 mt-3">
                                <Row>
                                    <Col lg={12}>
                                        {(this.state.managementFeeType === FIXED_MANAGEMENT_FEE) && (
                                            <FormGroup className="ml-3">
                                                <Label for="managementFeeFixedAmount">
                                                    Fixed Amount
                                                </Label>
                                                <IonIcon id="managegementFeeFixedAmount" icon={informationCircle}></IonIcon>
                                                <Input
                                                    id="managementFeeFixedAmount"
                                                    name="managementFeeFixedAmount"
                                                    placeholder='0'
                                                    value={this.state.managementFeeFixedAmount}
                                                    onChange={this.handleChange}
                                                    invalid={this.state.errors.managementFeeFixedAmount.length > 0}
                                                />
                                                <UncontrolledTooltip placement="top" target="managementFeeFixedAmount">
                                                    A management of the entered amount will be charged every month
                                                </UncontrolledTooltip>
                                                <FormFeedback>{this.state.errors.managementFeeFixedAmount}</FormFeedback>
                                            </FormGroup>
                                        )}
                                        {(this.state.managementFeeType === PERCENTAGE_MANAGEMENT_FEE) && (
                                            <FormGroup className="ml-3">
                                                <Label for="managementFeePercentage">
                                                    Percentage (%)
                                                </Label>
                                                <IonIcon id="managementFeePercentage" icon={informationCircle}></IonIcon>
                                                <Input
                                                    id="managementFeePercentage"
                                                    name="managementFeePercentage"
                                                    placeholder='0'
                                                    value={this.state.managementFeePercentage}
                                                    onChange={this.handleChange}
                                                    invalid={this.state.errors.managementFeePercentage.length > 0}
                                                />
                                                <UncontrolledTooltip placement="top" target="managementFeePercentage">
                                                    A management fee as a percentage of the rent amount collected will be charged every month
                                                </UncontrolledTooltip>
                                                <FormFeedback>{this.state.errors.managementFeePercentage}</FormFeedback>
                                            </FormGroup>
                                        )}
                                        {this.state.managementFeeType === PERCENTAGE_INVOICES && (
                                            <>
                                            <FormGroup className='mt-3 ml-3 mb-2'>
                                                <Label for="invoiceManagement">
                                                    Invoice Items
                                                </Label>
                                                <i id="invoicePercentage" className="fa fa-fw fa-info-circle ml-2"></i>
                                                <Typeahead
                                                    clearButton
                                                    multiple
                                                    options={this.state.invoiceItemOptions}
                                                    labelKey="label"
                                                    id="invoiceManagement"
                                                    name="invoiceItems"
                                                    placeholder="item name"
                                                    selected={this.state.invoiceItems}
                                                    onChange={this.handleChangedInvoiceItemOptions.bind(this)}
                                                />
                                                <UncontrolledTooltip placement="top" target="invoicePercentage">
                                                    A management fee as a percentage of the total amount of the selected invoice items will be charged every month
                                                </UncontrolledTooltip>
                                            </FormGroup>

                                            <FormGroup className="ml-3">
                                                <Label for="managementFeePercentage">
                                                    Percentage (%)
                                                </Label>
                                                <i id="managementFeePercentage" className="fa fa-fw fa-info-circle ml-2"></i>
                                                <Input
                                                    id="managementFeePercentage"
                                                    name="managementFeePercentage"
                                                    placeholder='0'
                                                    value={this.state.managementFeePercentage}
                                                    onChange={this.handleChange}
                                                    invalid={this.state.errors.managementFeePercentage.length > 0}
                                                />
                                                <UncontrolledTooltip placement="top" target="managementFeePercentage">
                                                    A management fee as a percentage of the rent amount collected will be charged every month
                                                </UncontrolledTooltip>
                                                <FormFeedback>{this.state.errors.managementFeePercentage}</FormFeedback>
                                            </FormGroup>
                                            </>
                                        )}
                                    </Col>
                                </Row>
                            </Row>
                        )
                    }
                </Col>
            </FormGroup>
        );
    }

    renderOptionalFields(){
        const tillTooltip = 'The store number given by Mpesa when you were given the Till Number';
        const paybillTooltip = 'Your MPESA paybill number';
        const companyNameTooltip = `The name of the company that owns this property. This will override the default company name in settings when sending messages to ${this.props.options.userAccountType === OCCUPANT_TYPE ? "tenants" : "members"}`;
        const payTooltip = `The instructions to ${this.props.options.userAccountType === OCCUPANT_TYPE ? "tenants" : "members"} on how to pay invoices for this property. This will override the default mpesa instructions`;
        return (
            <React.Fragment>

                {/* Water Charge */}
                <FormGroup row>
                    <CustomLabel sm={12} md={4} for="waterRate">
                        Water rate (optional)
                    </CustomLabel>

                    <Col style={{maxWidth: '450px'}} sm={12} md={7}>
                        <Input
                            id="waterRate"
                            name="waterRate"
                            placeholder='0'
                            value={this.state.waterRate}
                            onChange={this.handleChange}
                            invalid={this.state.errors.waterRate.length > 0}
                        />
                        <FormFeedback>{this.state.errors.waterRate}</FormFeedback>
                        <p>({this.props.currency.customerCurrency} per unit consumed)</p>
                    </Col>
                </FormGroup>

                {/* Electricity Charge */}
                <FormGroup row>
                    <CustomLabel sm={12} md={4} for="waterRate">
                        Electricity rate (optional)
                    </CustomLabel>

                    <Col style={{maxWidth: '450px'}} sm={12} md={7}>
                        <Input
                            id="electricityRate"
                            name="electricityRate"
                            placeholder='0'
                            value={this.state.electricityRate}
                            onChange={this.handleChange}
                            invalid={this.state.errors.electricityRate.length > 0}
                        />
                        <FormFeedback>{this.state.errors.electricityRate}</FormFeedback>
                        <p>({this.props.currency.customerCurrency} per unit consumed)</p>
                    </Col>
                </FormGroup>

                {/* Mpesa */}
                <FormGroup row>
                    <CustomLabel sm={12} md={4} for="mpesaShortcode">
                        MPESA (optional)
                    </CustomLabel>

                    <Col style={{maxWidth: '450px'}} sm={12} md={7}>
                        <IonRadioGroup name="mpesa" value={this.state.mpesaShortcodeType} onIonChange={this.handleRadioButtons.bind(this)}>
                            <IonRadio id="paybillRadio" value={PAYBILL} />&ensp;Paybill &emsp; &emsp;
                            <IonRadio id="tillNumberRadio" value={TILL_NUMBER} />&ensp;Till Number &emsp;
                        </IonRadioGroup>

                        <Row className="pb-3 mt-3">
                            <Col lg={12}>
                                {(this.state.mpesaShortcodeType === TILL_NUMBER || this.state.mpesaShortcodeType === PAYBILL) && (
                                    <FormGroup>
                                        <Label for="mpesaShortcode">
                                            {this.state.mpesaShortcodeType === TILL_NUMBER ? "Store Number" : "Paybill Number"}
                                        </Label>
                                        <IonIcon id="mpesaShortcode" icon={informationCircle}></IonIcon>
                                        <Input
                                            id="mpesaShortcodeInput"
                                            name="mpesaShortcode"
                                            placeholder=''
                                            value={this.state.mpesaShortcode}
                                            onChange={this.handleChange}
                                            invalid={this.state.errors.mpesaShortcode.length > 0}
                                        />
                                        <UncontrolledTooltip placement="top" target="mpesaShortcode">
                                            {this.state.mpesaShortcodeType === TILL_NUMBER ? tillTooltip : paybillTooltip}
                                        </UncontrolledTooltip>
                                        <FormFeedback>{this.state.errors.mpesaShortcode}</FormFeedback>
                                    </FormGroup>
                                )}

                            </Col>
                            <Col lg={12}>
                                {this.state.mpesaShortcodeType === TILL_NUMBER && (
                                    <FormGroup>
                                        <Label for="tillNumber">
                                            MPESA Till Number
                                        </Label>
                                        <Input
                                            id="tillNumberInput"
                                            name="tillNumber"
                                            placeholder=''
                                            value={this.state.tillNumber}
                                            onChange={this.handleChange}
                                            invalid={this.state.errors.tillNumber.length > 0}
                                        />
                                        <FormFeedback>{this.state.errors.tillNumber}</FormFeedback>
                                    </FormGroup>
                                )}
                            </Col>
                        </Row>
                    </Col>
                </FormGroup>

                {/** Penalty */}
                {this.renderPenaltyField()}

                {/* Tax Rate */}
                <FormGroup row>
                    <CustomLabel sm={12} md={4} for="taxRate">
                        Tax Rate % (optional)
                    </CustomLabel>

                    <Col style={{maxWidth: '450px'}} sm={12} md={7}>
                        <Input
                            id="taxRate"
                            name="taxRate"
                            value={this.state.taxRate}
                            onChange={this.handleChange}
                            invalid={this.state.errors.taxRate.length > 0}
                        />
                        <FormFeedback>{this.state.errors.taxRate}</FormFeedback>
                        <p>(Percentage tax rate)</p>
                    </Col>
                </FormGroup>
                <OtherRecurringBills
                    otherRecurringBillsItemOptions={this.state.otherRecurringBillsItemOptions}
                    otherRecurringBillsItems={this.state.otherRecurringBillsItems}
                    handleChangeBillsOptions={this.handleChangeBillsOptions}
                    errors={this.state.errors.otherRecurringBillsItems}
                    onClickAddItem={this.handleAddItem}
                    onClickDeleteItem={this.handleDeleteItem}
                    handleChangeBillsAmount={this.handleChangeBillsAmount}
                    propsItems={this.props.property ? this.props.property.otherRecurringBillsItems : null}
                    options={this.props.options}
                    form={"property"}
                    name={this.state.propertyName}
                    unitBills={Object.values(this.props.units).filter(unit => unit.otherRecurringBillsItems.length > 0 && unit.propertyId === this.state.propertyId).map(unit => ({
                        name: unit.unitName,
                        bill: unit.otherRecurringBillsItems.map(bill => bill.bill),
                        amount: unit.otherRecurringBillsItems.map(bill => bill.amount.toString())
                      }))}
                />

                {/* Management Fee */}
                {this.renderManagementFeeField()}

                {/* Address/Street Name */}
                <FormGroup row>
                    <CustomLabel sm={12} md={4} for="address">
                        Street Name (optional)
                    </CustomLabel>

                    <Col style={{maxWidth: '450px'}} sm={12} md={7}>
                        <Input
                            id="address"
                            name="address"
                            placeholder='Address / Closest street Name ...'
                            value={this.state.address}
                            onChange={this.handleChange}
                            invalid={this.state.errors.address.length > 0}
                        />
                        <FormFeedback>{this.state.errors.address}</FormFeedback>
                    </Col>
                </FormGroup>

                {/* Company name */}
                <FormGroup row>
                    <CustomLabel
                        sm={12} md={4}
                        for={"companyName"}
                    >
                        Company Name (Optional)
                        <IonIcon id="companyName" icon={informationCircle}></IonIcon>
                    </CustomLabel>

                    <Col style={{maxWidth: '450px'}} sm={12} md={7}>
                        <InputGroup>
                            <Input
                                id="companyNameInput"
                                name="companyName"
                                placeholder='Company Name ...'
                                value={this.state.companyName}
                                onChange={this.handleChange}
                                invalid={this.state.errors.companyName.length > 0}
                                ref={this.companyNameInput}
                            />
                            <UncontrolledTooltip placement="top" target="companyName">
                                {companyNameTooltip}
                            </UncontrolledTooltip>
                            <FormFeedback>{this.state.errors.companyName}</FormFeedback>
                        </InputGroup>
                    </Col>
                </FormGroup>


                {/*Notes */}
                <FormGroup row>
                    <CustomLabel sm={12} md={4} for="notes">
                        Notes (optional)
                    </CustomLabel>

                    <Col style={{maxWidth: '450px'}} sm={12} md={7}>
                        <InputGroup>
                            <Input
                                id="notes"
                                name="notes"
                                type="textarea"
                                placeholder='notes ...'
                                value={this.state.notes}
                                onChange={this.handleChange.bind(this)}
                                invalid={this.state.errors.notes.length > 0}
                            />
                            <FormFeedback>{this.state.errors.notes}</FormFeedback>
                        </InputGroup>
                    </Col>
                </FormGroup>

                {/*Payment Instructions */}
                <FormGroup row>
                    <CustomLabel sm={12} md={4} for={"paymentInstructions"}>
                    Payment Instructions (optional)
                    <IonIcon id="paymentInstructions" icon={informationCircle}></IonIcon>
                    </CustomLabel>

                    <Col style={{maxWidth: '450px'}} sm={12} md={7}>
                        <InputGroup>
                            <Input
                                id="paymentInstructionsInput"
                                name="paymentInstructions"
                                type="textarea"
                                placeholder='payment instructions ...'
                                value={this.state.paymentInstructions}
                                onChange={this.handleChange.bind(this)}
                                invalid={this.state.errors.paymentInstructions.length > 0}
                                ref={this.paymentInstructionsInput}
                            />
                            <UncontrolledTooltip placement="top" target="paymentInstructions">
                                {payTooltip}
                            </UncontrolledTooltip>
                            <FormFeedback>{this.state.errors.paymentInstructions}</FormFeedback>
                        </InputGroup>
                    </Col>
                </FormGroup>

            </React.Fragment>
        );
    }

    renderButtons(){
        return (
            <Row className="d-flex mb-4 pb-3 border-bottom border-dark justify-content-center">
                <IonButton
                    id='propertySubmit'
                    type="submit"
                    style={{ width: "80%" }}
                    className="shadow py-1"
                    disabled={this.state.numErrors > 0}>
                    {this.state.propertyId?
                        <span>Update Property</span>:
                        <span>Add Property</span>
                    }
                </IonButton>
                {!this.state.propertyId && (<IonButton
                        style={{ width: "80%" }}
                        fill='outline'
                        className="mx-2 mt-3 py-1"
                        onClick={this.handleClear.bind(this)}
                        >
                        Clear
                </IonButton>)}
            </Row>
        );
    }

    renderUnitFormButton(){
        return(
            <Button className="bg-white"
                style={{borderColor: colorTheme["primary"]["700"], color: colorTheme["primary"]["700"], animation: 'pulse 2s 3', marginRight: "3em"}}
                onClick={this.handleUnitsFormButton.bind(this)}
                data-testid="unitsFormButton"
            >
                Add Unit(s){" "}
                <IonIcon icon={arrowForwardOutline} className="mr-2" />
            </Button>
        )
    }

    render() {
        return (
            <Container>

                <Row className="mb-4">
                    <Col lg={3} md={4} sm={2} xs={2}>
                        {this.state.propertyId && (<IonButton
                            size="lg"
                            color="secondary"
                            className="mx-2 shadow"
                            id="deleteProperty"
                            onClick={this.handleDelete.bind(this, this.state.propertyId)}
                            disabled={this.state.readOnly}
                            data-testid="deleteProperty"
                        >
                            <IonIcon icon={trashOutline} />
                        </IonButton>)}
                    </Col>

                </Row>

                {this.state.showAlert && (
                    <div className="alert alert-success">
                        Create a property in order to add units in the next step.
                        <button type="button" className="close" onClick={this.handleAlertClose}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                )}

                <Row>
                    <Col lg={12}>
                    <Form onSubmit={this.handleSubmit.bind(this)}>
                        {this.renderRequiredFields()}

                        <ShowMoreButton
                            id="showOptionalFields"
                            onClick={(e) => {
                                e.preventDefault();
                                this.setState((prevState) => ({showOptionalFields: !prevState.showOptionalFields}))
                            }}
                            showMore={this.state.showOptionalFields}
                        />

                        {this.state.showOptionalFields && this.renderOptionalFields()}

                        {this.renderButtons()}
                    </Form>
                    </Col>
                </Row>

                {/* To be saved for next phase, handling urls, onboarding etc */}
                {/* <Row className="d-flex justify-content-end">
                    {this.state.propertyId && this.renderUnitFormButton()}
                </Row> */}

            </Container>
        );
    }
}

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(PropertyForm));